import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { FontScale, getFluidSpacing } from '../../../../helpers/utils';

interface CardInfoProps {
  title: string;
  subtitle: string;
}

/**
 * @description Card info component
 * @param {CardInfoProps} { title, subtitle }
 * @return {React.FC}
 */
const CardInfo: React.FC<CardInfoProps> = ({ title, subtitle }) => {
  return (
    <View style={styles.cardInfoContainer}>
      <View style={[styles.titleContainer, { marginBottom: getFluidSpacing(8, 10, 12) }]}>
        <Text style={[styles.titleText, { fontSize: FontScale.cardTitle() }]}>{title}</Text>
        <Text style={[styles.subtitleText, { fontSize: FontScale.cardSubtitle() }]}>
          {subtitle}
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  cardInfoContainer: {
    flex: 3,
    top: '17%',
    zIndex: 1
  },
  titleContainer: {
    marginBottom: 8
  },
  titleText: {
    fontWeight: '400',
    color: '#fff'
  },
  subtitleText: {
    fontWeight: '400',
    color: '#fff'
  },
  issuerText: {
    fontSize: 14,
    fontWeight: '400',
    color: '#fff'
  }
});

export default CardInfo;
